<template>
  <div style="background:#fff">
    <!-- 两日营 -->
    <div class="box">
      <div style="border: 1px solid #f0ad4e; padding:10px;border-radius: 10px;">
        <div style="text-align: center;font-size:13px;color:#f0ad4e;font-weight: 600;">
          两日及以内营
        </div>

        <div style="padding:5px;">
          <van-row>
            <van-col span="8">职位</van-col>
            <van-col span="8">积分</van-col>
            <van-col span="8">段位</van-col>
          </van-row>
        </div>
        <!-- 中队长 -->
        <div style="padding:5px;">
          <van-row>
            <van-col span="8">中队长</van-col>
            <van-col span="8">{{info.score_2d_m}}</van-col>
            <van-col span="8">
              <span
                :style="{color:info.score_2d_m_color}"
                class="ft700"
              >{{info.score_2d_m_title}}</span>
            </van-col>
          </van-row>
        </div>
        <!-- /中队长 -->

        <!-- 小队长 -->
        <div style="padding:5px;">
          <van-row>
            <van-col span="8">小队长</van-col>
            <van-col span="8">{{info.score_2d_s}}</van-col>
            <van-col span="8">
              <span
                :style="{color:info.score_2d_s_color}"
                class="ft700"
              >{{info.score_2d_s_title}}</span>
            </van-col>
          </van-row>
        </div>
        <!-- /小队长 -->
      </div>
    </div>
    <!-- /两日营 -->

    <!-- 三日营 -->
    <div class="box">
      <div style="border: 1px solid #f0ad4e; padding:10px;border-radius: 10px;">
        <div style="text-align: center;font-size:13px;color:#f0ad4e;font-weight: 600;">
          三日及以上营
        </div>

        <div style="padding:5px;">
          <van-row>
            <van-col span="8">职位</van-col>
            <van-col span="8">积分</van-col>
            <van-col span="8">段位</van-col>
          </van-row>
        </div>
        <!-- 中队长 -->
        <div style="padding:5px;">
          <van-row>
            <van-col span="8">中队长</van-col>
            <van-col span="8">{{info.score_3d_m}}</van-col>
            <van-col span="8">
              <span
                :style="{color:info.score_3d_m_color}"
                class="ft700"
              >{{info.score_3d_m_title}}</span>
            </van-col>
          </van-row>
        </div>
        <!-- /中队长 -->

        <!-- 小队长 -->
        <div style="padding:5px;">
          <van-row>
            <van-col span="8">小队长</van-col>
            <van-col span="8">{{info.score_3d_s}}</van-col>
            <van-col span="8">
              <span
                :style="{color:info.score_3d_s_color}"
                class="ft700"
              >{{info.score_3d_s_title}}</span>
            </van-col>
          </van-row>
        </div>
        <!-- /小队长 -->
      </div>
    </div>
    <!-- /三日营 -->

    <!-- 积分规则 -->
    <div style="text-align: center;">
      <van-button
        type="default"
        size="mini"
        @click="imgshow =true"
      >积分规则</van-button>
    </div>
    <!-- /积分规则 -->

    <!-- 积分明细列表 -->
    <div v-show="list!=null">
      <div v-if="list.length>0">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="(item,index) in list"
            :key="index"
            style="margin-top:10px"
          >
            <van-cell-group inset>
              <van-cell>
                <!-- 使用 title 插槽来自定义标题 -->
                <template #title>

                  <span class="custom-title">{{item.party_title}}</span>

                </template>

                <template #default>
                  <span style="margin-right:20px;">{{item.party_date}}</span>
                  <van-tag type="success">{{item.grade}}</van-tag>
                </template>
              </van-cell>
              <div class="box">
                <div class="box">
                  积分类别:
                  <span class="fr">{{item.party_type}}</span>
                </div>
                <div class="box">
                  职位:
                  <span class="fr">{{item.offer}}</span>
                </div>
                <div class="box">
                  积分结算:
                  <span
                    class="bg-red fr"
                    style="padding: 2px 5px;"
                  >{{item.score}}</span>
                </div>
              </div>

            </van-cell-group>
          </div>
        </van-list>
      </div>
      <div v-else>
        <van-empty description="暂无积分信息" />
      </div>
    </div>

    <van-dialog
      v-model="imgshow"
      confirmButtonText="关闭"
      confirmButtonColor="#000000"
    >
      <div style="height:80vh;overflow-y:auto"><img
          src="https://img.jiarixiaodui.com/jrhb/image/jifenguize.jpg"
          style="max-width:100%;"
        /></div>

    </van-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: {},
      list: null,
      loading: false,
      finished: false,
      imgshow: false,
    }
  },
  created() {
    this.getInfo()
    this.onLoad()
  },
  methods: {
    getInfo() {
      this.$axios.get('user/info').then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data
          //两日营段位颜色的处理
          data.score_2d_m_color = this.getColor(data.score_2d_m_title)
          data.score_2d_s_color = this.getColor(data.score_2d_s_title)
          data.score_3d_m_color = this.getColor(data.score_3d_m_title)
          data.score_3d_s_color = this.getColor(data.score_3d_s_title)
          this.info = data
          return
        }
      })
    },
    getColor(value) {
      if (value === '黄金') return '#D9D919'
      if (value === '白银') return '#DDDDDD'
      if (value === '青铜') return '#8C7853'
    },
    Ellipsis(value, length) {
      if (!value) return ''
      // 判断如果不是字符串的话那么就把他转换成字符串截取
      if (typeof value !== String) {
        value = value.toString()

        if (value.length > length) {
          return value.slice(0, length) + '...'
        }
      }

      return value
    },
    onLoad() {
      this.$axios.get('user/scorelog').then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          let data = res.data.data
          if (data == null) {
            this.list = []
            return
          }
          for (let i = 0; i < data.length; i++) {
            data[i].party_title = this.Ellipsis(data[i].party_title, 11)
          }
          console.log(data)
          this.list = data
          // 加载状态结束
          this.loading = false
          if (this.list.length >= data.length) {
            this.finished = true
          }
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.box {
  padding: 5px 18px;
  background-color: #fff;
}
::v-deep .van-col--8 {
  text-align: center;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}
.fr {
  float: right;
}
.bg-red {
  color: #e54d42;
  background-color: #fadbd9;
}
.ft700 {
  font-weight: 700;
}
</style>